import React from 'react';
import css from "./style.scss"


const LoadingPopup=(props)=>(
  <div className={css.loadingPopup}>
    Loading...
  </div>
)

export default LoadingPopup;



// WEBPACK FOOTER //
// ./src/components/subscriptions/modal/ui/loading_popup.js